import { doc, setDoc } from 'firebase/firestore'
import { getFirestoreInstance } from './firebase'

const DEFAULT_ON_PROCESS_ACTIONS = [
  { id: 'barista', label: 'Barista cup label printer', type: 'barista_cup_label' },
  { id: 'kitchen', label: 'Kitchen receipt printer', type: 'kitchen_receipt' },
]

const DEFAULT_SETTINGS = {
  confirmMoveToProcessingMessage:
    'Confirm move to processing? Payment will be requested.',
  onProcessActions: DEFAULT_ON_PROCESS_ACTIONS,
  currency: 'rupiah',
}

/**
 * Bootstrap a new place with default categories, settings, and counters.
 * Call after creating the place doc and member doc so the user has write access.
 * Stations are NOT seeded here so a new account never sees another account's
 * or a hardcoded default (Barista/Kitchen); the user adds their own stations.
 */
export async function bootstrapPlace(placeId: string): Promise<void> {
  const db = getFirestoreInstance()

  await setDoc(
    doc(db, 'places', placeId, 'categories', 'uncategorized'),
    { id: '__uncategorized__', name: 'Uncategorized' },
    { merge: true },
  )

  await setDoc(
    doc(db, 'places', placeId, 'settings', 'app'),
    DEFAULT_SETTINGS,
    { merge: true },
  )

  await setDoc(
    doc(db, 'places', placeId, 'counters', 'orders'),
    { orderDisplayNumber: 0 },
    { merge: true },
  )
}
